const apiUrl = "https://admin.compareairportparkingextras.co.uk/api/v1.0";

// const apiUrl = "https://cloudshosting.co.uk/api/v1.0";

export default apiUrl;
